import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class SwapEventVm {
	eventId: number;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'eventId': new UntypedFormControl(0, [...(validators['eventId'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): SwapEventVmFromFg {
		return new SwapEventVmFromFg(fg);
	}
}

export class SwapEventVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get eventId(): number {
		return this.fg.get('eventId').value;
	}
	set eventId(val) {
		this.fg.get('eventId').setValue(val);
	}
}
